export const LOCATED = 'LOCATED';

export const recordLocation = (location) => {
    return {
        type: LOCATED,
        payload: {
            location: location
        },
    };
};


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/location.js